import { render, staticRenderFns } from "./resourceMng.vue?vue&type=template&id=253a1be8&"
import script from "./resourceMng.vue?vue&type=script&lang=js&"
export * from "./resourceMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports